// extracted by mini-css-extract-plugin
export default {"blood-bank":"BloodBank_blood-bank__gvyjT","blood-bank__items":"BloodBank_blood-bank__items__sOTOP"};